import mapboxgl from 'mapbox-gl';
import MapService from '@/services/map.js';

const markerWifi = require('@/assets/img/marker-wifi.png');
const markerBluetooth = require('@/assets/img/marker-bluetooth.png');
const markerNFC = require('@/assets/img/marker-nfc.png');
const markerQRCode = require('@/assets/img/marker-qrcode.png');

const markersTypes = {
    '1' : markerWifi,
    '2' : markerBluetooth,
    '3' : markerNFC,
    '4' : markerQRCode,
    '5' : markerBluetooth,
};

export class IndoorMap {

    constructor(id, config, callBackLoad, center, zoom, pitching) {



        var that = this;

        //Initialisation des attributs
        this._container = "";
        this._config = {};
        this._map = null;
        this._geojson = null;
        this._currentMarker = null;
        this._canvas = null;
        this._isCursorOverPoint = false;
        this._isDragging = false;
        this._markerGhost = null;

        this._background = {
            data: '',
            width: 0,
            height: 0
        };

        mapboxgl.accessToken = MapService.accessToken;

        this._config = Object.assign(config);

        if (id != null) {
            this._container = id;
            this._config.container = id;
        }

        if (center != null) {
            this._config.center = center;
        }

        if (zoom != null) {
            this._config.zoom = zoom;
        }

        if (pitching == null) {
            pitching = false;
        }



        this._map = new mapboxgl.Map(config);


        this._canvas = this._map.getCanvasContainer();

        this._map.dragRotate._pitchWithRotate = pitching;

        this._map.addControl(new mapboxgl.AttributionControl(), 'bottom-left');

        this._map.addControl(new mapboxgl.NavigationControl());

        this._map.on('load', function (e) {


            that.initLayers();


            if (callBackLoad != null) {
                callBackLoad(e);
            }


        });
    }

    initLayers(){
        var that = this;

        var emptyGeoJson = {
            type: "FeatureCollection",
            features: []
        };
        var geojson = null;

        if(this._geojson != null){
            geojson = this._geojson;
        }
        else {
            geojson = emptyGeoJson;
        }

        that._map.addSource('geojson', {
            "type": "geojson",
            "data": geojson
        });

        that._map.addLayer({
            "id": "zones-fill",
            "type": "fill",
            "source": "geojson",
            'paint': {
                'fill-color': '#FFCC00',
                'fill-opacity': 0.4
            },
            "filter": ["==", "$type", "Polygon"]
        });

        that._map.addLayer({
            "id": "zones-line",
            "type": "line",
            "source": "geojson",
            'paint': {
                'line-color': '#FFCC00',
                'line-width': 5
            },
            "filter": ["==", "$type", "Polygon"]
        });

        that._map.loadImage(markerBluetooth, (error, imageBT) => {
            that._map.loadImage(markerWifi, (error, imageWF) => {
                that._map.loadImage(markerNFC, (error, imageNFC) => {
                    that._map.loadImage(markerQRCode, (error, imageQR) => {


                        that._map.addImage('marker-2', imageBT);
                        that._map.addImage('marker-5', imageBT);
                        that._map.addImage('marker-1', imageWF);
                        that._map.addImage('marker-3', imageNFC);
                        that._map.addImage('marker-4', imageQR);

                        that._map.addLayer({
                            "id": "markers",
                            "type": "symbol",
                            "source": "geojson",
                            "layout": {
                                "icon-image": "marker-{type}",
                                "icon-size": 1,
                                "icon-allow-overlap": true,
                            },
                            "filter": ["==", "$type", "Point"]
                        });

                    });
                });
            });
        });
    }

    addGeoJson(geojson) {

        this._geojson = geojson;

        this._map.getSource('geojson').setData(geojson);

    }

    addMarker(properties) {

        if(this._geojson != null){

            var marker = {
                "geometry":{
                    "coordinates":[0,0],
                    "type":"Point"
                },
                "type":"Feature",
                "properties":properties
            };

            this._geojson.features.push(marker);
            this._map.getSource('geojson').setData(this._geojson);

        }

    }

    addPolygon(feature) {

        if(this._geojson != null){

            this._geojson.features.push(feature);
            this._map.getSource('geojson').setData(this._geojson);

        }

    }

    removePolygon(id){
        var that = this;

        for( var i=0; i <this._geojson.features.length;i++ ){
            if(this._geojson.features[i].properties.id == id){
                that._geojson.features.splice(i,1);
                break;
            }
        }

        this._map.getSource('geojson').setData(this._geojson);
    }

    clearFeatures(){
        this._geojson = {
            type: "FeatureCollection",
            features: []
        };

        this._map.getSource('geojson').setData(this._geojson);
    }

    addDragAndDrop(callbackDrop) {

        var that = this;

        this._callbackDrop = callbackDrop;

        this._map.on('mouseenter', 'markers', function (e) {
            if(!that._isDragging){
                that._currentMarker = e.features[0].properties;
            }


            that._canvas.style.cursor = 'move';
            that._isCursorOverPoint = true;
            that._map.dragPan.disable();
        });

        this._map.on('mouseleave', 'markers', function () {

            if(!that._isDragging) {
                that._canvas.style.cursor = '';
                that._isCursorOverPoint = false;
                that._map.dragPan.enable();
            }
        });

        this._map.on('mousedown', function(e){

            if (!that._isCursorOverPoint) return;

            that._isDragging = true;

            // Set a cursor indicator
            that._canvas.style.cursor = 'grab';

            that._markerGhost.getElementsByTagName('img')[0].setAttribute('src',markersTypes[that._currentMarker.type]);
            that._markerGhost.style.left = (e.originalEvent.offsetX-25)+'px';
            that._markerGhost.style.top = (e.originalEvent.offsetY-25)+'px';

            that._map.setFilter('markers',["!=","id",that._currentMarker.id]);


            // Mouse events
            that._map.on('mousemove', function(e){

                if (!that._isDragging) return;
                var coords = e.lngLat;


                // Set a UI indicator for dragging.
                that._canvas.style.cursor = 'grabbing';


                that._markerGhost.style.left = (e.originalEvent.offsetX-25)+'px';
                that._markerGhost.style.top = (e.originalEvent.offsetY-25)+'px';


            });
            that._map.once('mouseup', function(e){


                if (!that._isDragging) return;
                var coords = e.lngLat;

                // Print the coordinates of where the point had
                // finished being dragged to on the map.
                that._geojson.features[that._currentMarker.index].geometry.coordinates = [coords.lng, coords.lat];
                that._map.getSource('geojson').setData(that._geojson);

                that._map.setFilter('markers',null);

                that._markerGhost.style.left = -40+'px';
                that._markerGhost.style.top = -40+'px';

                if(that._callbackDrop){
                    that._callbackDrop(that._currentMarker,coords);
                }


                that._canvas.style.cursor = '';
                that._isDragging = false;
                that._currentMarker = null;

                // Unbind mouse events
                that._map.off('mousemove');
            });
        });


        this._markerGhost = document.getElementById(this._config.container).getElementsByClassName('marker-ghost')[0];
    }

    addBackground(image) {
        if(image.data != ''){

            if(this._map.getSource('background')){
                this._map.removeSource('background')
            }

            this._background.data = image.data;
            this._background.width = image.width/1000;
            this._background.height = image.height*-1/1000;


            this._map.addSource('background', {
                "type": "image",
                "url": this._background.data,
                "coordinates": [
                    [0,0],
                    [this._background.width,0],
                    [this._background.width,this._background.height],
                    [0,this._background.height]
                ]
            });
            this._map.addLayer({
                "id": "background",
                "source": "background",
                "type": "raster",
                "paint": {"raster-opacity": 1}
            });
            this._map.setMaxBounds([[-0.5, this._background.height-0.5], [this._background.width+0.5,0.5]]);
            this._map.setCenter([this._background.width/2,this._background.height/2]);
            this._map.setZoom(8.5);

            this._map.moveLayer("zones-fill");
            this._map.moveLayer("zones-line");
            this._map.moveLayer("markers");
        }
    }

    _attributes() {


    }

}
